import { uniq } from 'rambda';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { SEARCH_HISTORY_STORAGE_KEY } from '@/utils/constants';
import { dbStore } from '@/utils/storage';

type SearchHistoryState = {
  searchHistory: string[];
};

type SearchHistoryAction = {
  pushSearchHistory: (search: string) => void;
  removeSearchHistory: (search: string) => void;
  clearAllSearchHistory: () => void;
};

type SearchHistoryStore = SearchHistoryState & SearchHistoryAction;

const initialState: SearchHistoryState = {
  searchHistory: [],
};

const useSearchHistoryStore = create<SearchHistoryStore>()(
  persist(
    (set) => ({
      ...initialState,
      pushSearchHistory: (search) =>
        set(({ searchHistory }) => ({ searchHistory: uniq([search, ...searchHistory]).slice(0, 20) })),
      removeSearchHistory: (search) =>
        set(({ searchHistory }) => ({ searchHistory: searchHistory.filter((s) => s !== search) })),
      clearAllSearchHistory: () => set(() => ({ searchHistory: [] })),
    }),
    {
      name: SEARCH_HISTORY_STORAGE_KEY,
      version: 3,
      storage: dbStore,
      partialize: (state) => ({
        searchHistory: state.searchHistory,
      }),
      migrate: () => ({
        searchHistory: [],
      }),
    },
  ),
);

export default useSearchHistoryStore;
